import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import {
  ADMINDASHBOARD_DATA_GET,
  ADMINDASHBOARD_DATA_SUCCESS
} from "./actionTypes"

import { 
  adminDashboardDataGet,
  adminDashboardDataSuccess
} from "./actions"

import { 
  HOSTNAME,
  ADMINDASHBOARD

} from "config/config"

import { apiError } from "store/actions"
import axios from "axios"
import { toast } from "react-toastify"

// const fireBaseBackend = getFirebaseBackend()
const getUserData = JSON.parse(localStorage.getItem("authUser")) 

function* dashboardData({ payload: { query, history } }) {
  try {
            // alert(query.query)
            let url = `${HOSTNAME}${ADMINDASHBOARD}`
            let config = {
              method: 'get',
              maxBodyLength: Infinity,
              url:url,
              headers: { 
                'Authorization': `${getUserData.userData.token}`
              }
            };


            const response = yield axios.request(config);
            console.log("+++++++++++++",response);
            if (response.status === 200) {
              yield put(adminDashboardDataSuccess(response.data.data));
              // console.log("---======----==--=-=-=-=-",response.data.results.data)
            }
            else if (response.status === 401){
              localStorage.removeItem('authUser'); 
              window.location.href = '/pre-login';
            }
             else {
              toast.error(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
              yield put(apiError(response.data.message));
            }

  } catch (error) {
    // console.log("error======",error)
    toast.error(error.response.data.message, {
      position: toast.POSITION.TOP_RIGHT,
    })
    if(error.response.status==401){
      localStorage.removeItem('authUser'); 
      window.location.href = '/pre-login';
    }
    yield put(apiError(error))
  }
}

function* dashboardDataSaga() {
  yield takeEvery(ADMINDASHBOARD_DATA_GET, dashboardData) 
}

export default dashboardDataSaga
